<template>
  <div class="container">
  </div>
</template>

<script>
  export default {
    name: "BlankPage"
  }
</script>

<style scoped>
  .container {
    background-color: white;
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/BlankPage.vue